import { borderRadius, ButtonGroup, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 16px 16px;
`;

export const TitleAndButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  ${typographyV2.titleBase}
  color: var(--text-default);
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  border: 1px solid var(--border-soft);
  ${borderRadius.r3}

  ${ButtonGroup.Styles.ButtonGroupRoot} {
    padding: 4px;
  }

  ${ButtonGroup.Styles.ButtonGroupItem} {
    ${borderRadius.r2}
    ${typographyV2.bodySm};
    height: 24px;
    padding: 0;
  }
`;

export const TooltipLabel = styled.div`
  white-space: nowrap;
`;
